import { useEffect } from 'react'

import { fetchProperty } from 'actions/PropertyActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'

interface Options {
  disabled?: boolean
}

type Return = [
  property: App.Property.Property | undefined,
  fetching: boolean,
  error: any,
]

function useProperty(
  propertyId: string | undefined = '',
  options: Options = {},
): Return {
  const dispatch = useAppDispatch()

  const property = useAppSelector(state => state.offer.properties[propertyId])

  const isFetchRequired = !!propertyId && !options.disabled && !property

  useEffect(() => {
    if (isFetchRequired) {
      dispatch(fetchProperty(propertyId))
    }
  }, [dispatch, isFetchRequired, propertyId])

  return [property?.property, property?.fetching ?? isFetchRequired, property?.error]
}

export default useProperty
